import type { TenantWithFeature } from "./connect";

export function getIsInTargetCity(
  tenant: TenantWithFeature,
  cityAddress: string,
) {
  if (tenant.slug === "marumori") {
    return cityAddress.startsWith("宮城県伊具郡丸森町");
  }

  if (tenant.slug === "miyagi") {
    return cityAddress.startsWith("宮城県");
  }

  if (tenant.slug === "shiga-otsu") {
    return cityAddress.startsWith("滋賀県大津市");
  }

  if (tenant.slug === "shiga-otsu-pay") {
    return cityAddress.startsWith("滋賀県大津市");
  }

  if (tenant.slug === "kyoto-kyoto") {
    return cityAddress.startsWith("京都府京都市");
  }

  return true;
}

// 対象地域外等、利用できないケースで機能を無効にする
export function disableFeatures(tenant: TenantWithFeature): TenantWithFeature {
  return {
    ...tenant,
    feature: {
      invitation: false,
      lottely: false,
      storeList: tenant.feature.storeList,
      payment: tenant.feature.payment,
      charge: tenant.feature.charge,
      transfer: tenant.feature.transfer,
    },
  };
}
